@if (portfolio()) {
  <div class="row mb-5 align-items-center">
    <div class="col-auto">
      <h1>{{ this.portfolio().name }}</h1>
    </div>
    <div class="col-auto ms-auto">
      <div class="btn-group toggle-btn-group flex-wrap">
        @defer (when hasAILicense()) {
          <cfp-ai-button (clicked)="showAddBuildingFlow.emit(true)">
            {{ 'ai.estimation.button.portfolioHeader' | translate }}
          </cfp-ai-button>
        }
        <cfp-button
          [disabled]="filtersButtonDisabled()"
          (clicked)="showFiltersSidePanel.emit()"
          class="toggle-filter-button"
          [buttonStyle]="activeFiltersCount() > 0 ? 'primary' : 'form-control'"
          [buttonOutline]="activeFiltersCount() > 0"
          [dataTest]="'portfolioOverviewToggleFilterButton'"
          aria-haspopup="true"
        >
          <cfp-icon class="me-2" [icon]="'sliders'" />
          <span>{{ 'filter' | translate }}</span>
          @if (activeFiltersCount() > 0) {
            <cfp-badge [badgeStyle]="'primary'">{{ activeFiltersCount() }}</cfp-badge>
          }
        </cfp-button>
        <cfp-button-toggle
          [id]="'portfolioBusinessCaseShowM2'"
          liveRegionStatusUpdater
          [statusUpdateOnClick]="'liveAreaRegion.contentUpdatedBelow' | translate"
          [defaultButtonStyle]="'form-control'"
          [buttonOutline]="showM2()"
          [pressed]="showM2()"
          (clicked)="toggleM2.emit()"
          [dataTest]="'portfolioShowPerAreaButton'"
          [ariaLabel]="'aria.label.toggleSquareUnit' | translate"
        >
          <cfp-measurement-area />
        </cfp-button-toggle>
        @if (showLabelGroup()) {
          <cfp-select-label-group />
        }
        @defer (when hasPortfolioBuildingsRoadmapReportLicense()) {
          @if (customPortfolioHeaderReportButton) {
            <ng-container
              *ngComponentOutlet="
                customPortfolioHeaderReportButton;
                inputs: {
                  portfolioId: portfolioId()
                }
              "
            />
          } @else {
            <cfp-report-buildings-download-button
              [portfolioId]="portfolioId()"
              [fileName]="reportFileName()"
              [buttonOutline]="false"
            />
          }
        }
        @defer (when hasPortfolioNotesLicense()) {
          <cfp-notes-button [portfolioId]="portfolioId()" />
        }
        @if (hasPortfolioReportLicense()) {
          <cfp-portfolio-pdf-download-button
            [url]="reportUrl()"
            [fileName]="reportFileName()"
            [dataAnalytics]="'downloadPortfolioReportButton'"
          >
            {{ 'downloadReport' | translate }}
          </cfp-portfolio-pdf-download-button>
        }
        @if (!hideManageBuildingTags) {
          <cfp-dropdown
            [icon]="'ellipsis-v'"
            [ariaLabel]="'portfolioDownActionsTitle' | translate"
            class="cfp-dropdown-options"
            [dataTest]="'portfolioDownActionsTitle'"
          >
            <button (click)="showTags()" class="dropdown-item" data-test="manageTags">
              <cfp-icon [icon]="'tag'" />
              <span>{{ 'tags.manage' | cfpTranslate }}</span>
            </button>
          </cfp-dropdown>
        }
      </div>
    </div>
  </div>
}
